import { render, staticRenderFns } from "./regist-confirm.vue?vue&type=template&id=75d93618&scoped=true&"
import script from "./regist-confirm.vue?vue&type=script&lang=ts&"
export * from "./regist-confirm.vue?vue&type=script&lang=ts&"
import style0 from "./regist-confirm.vue?vue&type=style&index=0&id=75d93618&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d93618",
  null
  
)

export default component.exports